import React, { memo, Dispatch, SetStateAction } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { Pagination } from 'transfix-ui/components/Pagination'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Table, TableBody } from 'transfix-ui/components/Table'
import { ILaneHistory } from 'types/carrier'
import { LaneRow } from './LaneRow'
import { LaneTableHeader } from './LaneTableHeader'
import { StatusRow } from './StatusRow'

interface ILaneTableProps {
  lanes: ILaneHistory[]
  pageCount: number
  totalCount: number
  setPageCount: Dispatch<SetStateAction<number>>
  firstLoad: boolean
  fetching: boolean
  error?: string
  perPage: number
}

const makeKey = ({
  deliveryCity,
  deliveryStateCode,
  pickupCity,
  pickupStateCode,
  shipmentCount,
}: ILaneHistory) =>
  [pickupCity, pickupStateCode, deliveryCity, deliveryStateCode, shipmentCount].join('-')
const refreshPage = () => global.location.reload()

export const LanesTable = memo<ILaneTableProps>(
  ({ error, fetching, firstLoad, lanes, pageCount, perPage, setPageCount, totalCount }) => {
    if (fetching && firstLoad) {
      return (
        <div className='pa6'>
          <Spinner position='relative' />
        </div>
      )
    }
    if (!firstLoad && !fetching && lanes.length === 0 && !error) {
      return <p className='tc'>This carrier hasn’t been assigned any shipments yet.</p>
    }

    const onPageChange = (pageNumber: number) => setPageCount(pageNumber - 1)
    return (
      <>
        <Table>
          <LaneTableHeader />
          <TableBody>
            {error && (
              <StatusRow>
                <div className='pv4'>
                  Sorry, there was an issue loading results. Please try refreshing your page.
                </div>
                <Button variant='text' noPadding onClick={refreshPage}>
                  Refresh your page
                </Button>
              </StatusRow>
            )}
            {fetching ? (
              <StatusRow>
                <Spinner position='relative' />
              </StatusRow>
            ) : (
              lanes.map(lane => <LaneRow key={makeKey(lane)} lane={lane} />)
            )}
          </TableBody>
        </Table>
        <div className='tc'>
          <Pagination
            currentPage={pageCount + 1}
            numberOfPages={Math.ceil(totalCount / perPage)}
            onPageChange={onPageChange}
          />
        </div>
      </>
    )
  }
)
